import { memo } from "react";
import moment from "moment";

import { ReportTabSection, ReportTimeRangeType } from "types/Reports";
import ReportTabList from "./ReportTabList";

type ReportTabItemProps = {
    sections: ReportTabSection[];

    timeRangeType: ReportTimeRangeType;

    categories: string[];
    time: moment.Moment;

    dateFormat: string;
};

export default memo(function ReportTabItem({
    sections,

    timeRangeType,

    categories,
    time,

    dateFormat,
}: Readonly<ReportTabItemProps>) {
    if (sections.length === 0) {
        return <></>;
    }

    return (
        <section className="report-tab-item">
            {sections.map((section, index) => {
                if (section.chartSeries.length === 0) {
                    return null;
                }

                let className = 'report-tab-section';
                if (index === 0) {
                    className = 'report-tab-section report-tab-section--first';
                }

                return <section className={className} key={`report-tab-item-${section.title}-${section.itemType}-${index + 1}`}>
                    {section.titleHidden ? <></> : <p className="report-tab-section-title">{section.title}</p>}
                    <ReportTabList
                        timeRangeType={timeRangeType}
                        itemType={section.itemType}

                        isLoading={section.isLoading}

                        chartSeries={section.chartSeries}
                        prevChartSeries={section.prevChartSeries}

                        categories={categories}
                        time={time}

                        dateFormat={dateFormat}
                        highlightClassName={section.highlightClassName}
                        color={section.color}
                    />
                </section>;
            })}

            <p className="report-tab-section-asterisk">*The value is rounded for display. Actual precision is higher.</p>
        </section>
    );
});
